import '@progymedia/gatsby-theme-boutik-ecommerce/src/components/ProductListing/ProductListing.scss';
import './_PartsListing.scss';

import { LocalizedLink } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import React from 'react';
import manualIcon from '@progymedia/sbi-web-drolet/src/images/icons/manual.svg';
import partIcon from '@progymedia/sbi-web-drolet/src/images/icons/part.svg';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export default function _PartsListing(props) {
    const { t } = useTranslation('boutik');
    const { currentLocale } = usePageLocalization();
    const { columns, products } = props;

    return (
        <div className='partListing'>
            {products.length === 0 ? (
                <div className='resultNumber'>{t('archives.no-result')}</div>
            ) : (
                <>
                    <div className='resultNumber'>
                        {products.length} {t('archives.results')}
                    </div>
                    <table className='partsTable'>
                        <thead className='header'>
                            <tr>
                                <th>{t('archives.product-name')}</th>
                                <th>{t('archives.product-number')}</th>
                                <th>{t('archives.product-serial')}</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products
                                .sort((a: any, b: any) => {
                                    if (
                                        a.title[currentLocale] <
                                        b.title[currentLocale]
                                    )
                                        return -1;
                                    if (
                                        a.title[currentLocale] >
                                        b.title[currentLocale]
                                    )
                                        return 1;
                                    return 0;
                                })
                                .map((product: any, index: number) => {
                                    const serialNumberFrom =
                                        product.attributes?.serial_number_from
                                            ?.values[0]['en_CA'];
                                    const serialNumberTo =
                                        product.attributes?.serial_number_to
                                            ?.values[0]['en_CA'];

                                    return (
                                        <tr
                                            className='productInfos'
                                            key={index}
                                        >
                                            <td className='productName'>
                                                {product.title?.[currentLocale]}
                                            </td>
                                            <td className='productCode'>
                                                {product.code}
                                            </td>
                                            <td className='productSerialNumber'>
                                                {serialNumberFrom &&
                                                !serialNumberFrom?.startsWith(
                                                    '-'
                                                ) &&
                                                serialNumberTo &&
                                                !serialNumberTo?.startsWith(
                                                    '-'
                                                ) &&
                                                serialNumberTo !== 'NULL'
                                                    ? t(
                                                          'archives.serial-fromto',
                                                          {
                                                              from: serialNumberFrom,
                                                              to: serialNumberTo,
                                                          }
                                                      )
                                                    : serialNumberFrom ===
                                                          undefined ||
                                                      serialNumberFrom?.startsWith(
                                                          '-'
                                                      )
                                                    ? '--'
                                                    : t(
                                                          'archives.serial-from',
                                                          {
                                                              from: serialNumberFrom,
                                                          }
                                                      )}
                                            </td>
                                            <td className='actions'>
                                                {product.parts && (
                                                    <LocalizedLink
                                                        className='action'
                                                        to={`/archives/${product.code.toLowerCase()}/`}
                                                    >
                                                        <span>
                                                            {t(
                                                                'archives.see-parts'
                                                            )}
                                                        </span>
                                                        <img
                                                            width={30}
                                                            src={partIcon}
                                                            alt={partIcon}
                                                            title={t(
                                                                'part-tooltip'
                                                            )}
                                                        />
                                                    </LocalizedLink>
                                                )}

                                                {product?.documents && (
                                                    <LocalizedLink
                                                        className='action'
                                                        to={`/archives/${product.code.toLowerCase()}/manuals/`}
                                                    >
                                                        <span>
                                                            {t(
                                                                'archives.see-manuals'
                                                            )}
                                                        </span>
                                                        <img
                                                            width={30}
                                                            src={manualIcon}
                                                            alt={manualIcon}
                                                            title={t(
                                                                'manual-tooltip'
                                                            )}
                                                        />
                                                    </LocalizedLink>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                </>
            )}
        </div>
    );
}
